export default __webpack_public_path__ + "static/media/logo.e19a2b8c.svg";